import axios from "axios";
import { getConfig } from '../configService';

export class DashboardService {
    static keycloak = null;

    static get calendarServiceBaseUrl() {
        if ((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
            return "http://localhost:5050/v1";
        }
        return `${getConfig().apiBaseUrl}/calendar/v1`;
    }

    static get paymentServiceBaseUrl() {
        if ((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
            return "http://localhost:5047/v1";
        }
        return `${getConfig().apiBaseUrl}/payment/v1`;
    }

    static async getProviderStats(providerId, from, to, granularity) {
        if (!DashboardService.keycloak || !DashboardService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${providerId}/stats?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&granularity=${granularity}`,
                headers: {
                    "Authorization": "Bearer " + DashboardService.keycloak.token
                }
            });
            return response.data;
        } catch (error) {
            console.error("Failed to fetch provider stats:", error);
            throw error;
        }
    }

    static async getProviderRevenue(providerId, from, to, granularity) {
        if (!DashboardService.keycloak || !DashboardService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const response = await axios({
                method: 'get',
                url: `${this.paymentServiceBaseUrl}/Pay/providers/${providerId}/revenue?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&granularity=${granularity}`,
                headers: {
                    "Authorization": "Bearer " + DashboardService.keycloak.token
                }
            });
            return response.data;
        } catch (error) {
            console.error("Failed to fetch provider revenue:", error);
            throw error;
        }
    }
}
